<svelte:options tag="gema-link-box" />

<script>
    import { afterUpdate } from 'svelte';
    import { Props, Routes } from "web-adapter-js";

    const props = new Props();
    const route = new Routes();

    export let key = '';
    export let data = {
        title: '',
        items: [],
        selector: '',
        id: ''
    };

    afterUpdate(() => {
        const property = props.find(`gema-link-box-${key}`);
        if (!!key && property) {  data = property; }
    });

    const navigation = (path) => route.emit(path, { });
</script>

<main>
    <section class="section-badge">
        <div class="container">
            <h1 class="title"> { data.title } </h1>
            <div class="badge-row">
                {#each data.items as item}
                    <a on:click={navigation(item.href)} class="badge" > { item.description } </a>
                {/each}
            </div>
        </div>
    </section>
</main>

<style type="text/scss">
    @import '../../../styles';
    @import '../../../scss/abstracts/mixins';

    .section-badge {
        border-radius: 15px;
        background-color: #ffffff;
        margin-bottom: 30px;
        .container {
            padding: 50px 0 25px 50px !important;
            .title { @include font-poppins(40px, 600, normal, normal, 1.2,  -1.5px, #332927); }
            .badge-row {
                display: flex;
                align-items: stretch;
                justify-content: flex-start;
                flex-direction: row;
                flex-wrap: wrap;
                .badge {
                    line-height: 1em;
                    height: 32px;
                    border: 2px solid #efece9;
                    border-radius: 8px;
                    padding: 0 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: row;
                    font-size: 14px;
                    margin: 5px;
                    @include font-poppins(14px, 400, normal, normal, normal, normal, #b8b4b4);
                    text-align: center;
                    cursor: pointer;
                    text-decoration: none;
                }
            }
        }
    }
</style>
